/*
 *   File : manage-story.js
 *   Author : https://evoqins.com
 *   Description : manage story component
 *   Integrations : story/list
 *   Version : 1.0.1
 */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setPageTitle, setSearchEnabled } from "../../Redux/Ui/ui.slice";
import { PrimaryButton } from "../../Components/Buttons";
import { useNavigate } from "react-router-dom";
import { StoryCard } from "../../Components/Cards";
import { EmptyScreen, Loader } from "../../Components/Other";
import { APIService } from "../../Service";

export default function ManageStory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loader, setLoader] = useState(false);
  const [stories, setStories] = useState([]);
  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    dispatch(setPageTitle(["Manage Story"]));
    dispatch(setSearchEnabled(false));
    _getStories();
  }, []);

  // Fetch stories
  const _getStories = () => {
    setLoader(true);
    APIService(false, "story/list")
      .then((res) => {
        if (res.status_code === 200 && Array.isArray(res.data)) {
          setStories(res.data);
          setIsEmpty(res.data.length === 0);
        } else {
          setStories([]);
          setIsEmpty(true);
        }
      })
      .catch(() => {
        setStories([]);
        setIsEmpty(true);
      })
      .finally(() => setLoader(false));
  };

  if (loader) return <Loader />;
  return (
    <div className="d-flex flex-column row-gap-3 pt-3">
      <div className="d-flex justify-content-end">
        <PrimaryButton
          name={"Add Stories"}
          ClassName="bg-oxford-blue fw-400 fs-16 lh-24 text-white rounded-16 py-2 px-3"
          onPress={() => navigate("/manage-story/add")}
        />
      </div>
      {isEmpty ? (
        <EmptyScreen message="No Stories found" />
      ) : (
        <div className="d-flex flex-column e-glass-card rounded-24 shadow-none p-24 bg-transparent row-gap-3">
          <h3 className="fw-500 fs-14 lh-20 text-black mb-1">Live Stories</h3>

          <div className="d-flex flex-wrap col-g-24 rg-24 pb-3">
            {stories.map((story) => (
              <StoryCard
                key={story.story_id}
                img={story.cover_image}
                onClick={() => navigate(`/manage-story/edit/${story.story_id}`)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
